module.exports = __webpack_public_path__ + "static/media/4.e2b32c36.jpg";